// src/reducers/platformSettingsReducer.js
import {
    GET_PLATFORM_SETTINGS_REQUEST,
    GET_PLATFORM_SETTINGS_SUCCESS,
    GET_PLATFORM_SETTINGS_FAIL,
    SAVE_PLATFORM_SETTINGS_REQUEST,
    SAVE_PLATFORM_SETTINGS_SUCCESS,
    SAVE_PLATFORM_SETTINGS_FAIL
  } from '../actions/types';
  
  const initialState = {
    settings: null,
    loading: false,
    error: null,
    success: false
  };
  
  export const platformSettingsReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_PLATFORM_SETTINGS_REQUEST:
      case SAVE_PLATFORM_SETTINGS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
          success: false
        };
  
        case GET_PLATFORM_SETTINGS_SUCCESS:
            // Extract the first item from the data array, or null if empty
            const settingsData = action.payload.data && action.payload.data.length > 0 
              ? action.payload.data[0] 
              : null;
            
            return {
              ...state,
              settings: settingsData,
              loading: false,
              error: null
            };
  
      case SAVE_PLATFORM_SETTINGS_SUCCESS:
        return {
          ...state,
          loading: false,
          settings: action.payload,
          success: true,
          error: null
        };
  
      case GET_PLATFORM_SETTINGS_FAIL:
      case SAVE_PLATFORM_SETTINGS_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
          success: false
        };
  
      default:
        return state;
    }
  };